import React from "react";
import { useContent } from "../i18n/LanguageContext";

export default function Process() {
  const process = useContent().process;
  return (
    <section className="py-20 lg:py-28 bg-[#faf8f4]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto reveal">
          <div className="eyebrow mb-4">{process.eyebrow}</div>
          <h2 className="font-serif-lux text-4xl lg:text-5xl text-[#16233d] font-semibold">{process.title}</h2>
          <p className="mt-4 text-[#5c6577] text-lg">{process.text}</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {process.steps.map((s) => (
            <div key={s.no} className="relative bg-white rounded-xl border border-[#efe9dd] p-7 card-lift">
              <div className="font-serif-lux text-6xl text-[#efe4d0] leading-none">{s.no}</div>
              <h3 className="font-serif-lux text-2xl text-[#16233d] mt-3 mb-2">{s.title}</h3>
              <p className="text-[#5c6577] text-sm leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mt-16 border-t border-[#e7e2d8] pt-12">
          {process.stats.map((st) => (
            <div key={st.label} className="text-center">
              <div className="font-serif-lux text-4xl lg:text-5xl text-[#b08d57]">{st.value}</div>
              <div className="text-sm text-[#5c6577] mt-2">{st.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
